"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TrashSolid: function() {
        return TrashSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const TrashSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.44152 1C8.15023 1 7.00381 1.82629 6.59547 3.05132L6.27924 4H3C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H4V20C4 21.6569 5.34315 23 7 23H17C18.6569 23 20 21.6569 20 20V6H21C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4H17.7208L17.4045 3.05132C16.9962 1.82629 15.8498 1 14.5585 1H9.44152ZM15.6126 4L15.5072 3.68377C15.3711 3.27543 14.9889 3 14.5585 3H9.44152C9.01109 3 8.62895 3.27543 8.49284 3.68377L8.38743 4H15.6126ZM10 9C10.5523 9 11 9.44771 11 10V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V10C9 9.44771 9.44772 9 10 9ZM15 10C15 9.44771 14.5523 9 14 9C13.4477 9 13 9.44771 13 10V17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17V10Z",
        fill: "currentColor"
    })
}), "TrashSolid");
const _default = TrashSolid;
